<template>
    <router-view v-slot="{ Component }">
        <Layout v-if="$route.meta.auth">
            <component :is="Component"></component>
        </Layout>

        <component :is="Component" v-else></component>
    </router-view>
</template>

<script setup lang="ts">
import { configureYupLocale } from '@/utils/yupConfig';
import Layout from './views/layouts/donor/Layout.vue';

configureYupLocale();
</script>
